module.exports = __webpack_public_path__ + "static/Auto-Share-10-e1407759121495-b5cede6aab16a14cee49f00d53bdc294.jpg";